__turbopack_context__.v({
  "disclaimer": "CampaignForm-module__a-xAdG__disclaimer",
  "formContainer": "CampaignForm-module__a-xAdG__formContainer",
  "input": "CampaignForm-module__a-xAdG__input",
  "messageContainer": "CampaignForm-module__a-xAdG__messageContainer",
  "select": "CampaignForm-module__a-xAdG__select",
  "submitButton": "CampaignForm-module__a-xAdG__submitButton",
  "textContainer": "CampaignForm-module__a-xAdG__textContainer",
  "wrapper": "CampaignForm-module__a-xAdG__wrapper",
});
